export default {
  /*
   * index() permite obtener los horarios de paso por 2 paradas de una sublínea
   */
  async index(params) {
    const response = await Vue.http.get('passenger_app/v1/schedule/by_stops', {params})
    return response.data.data
  }
}
